import { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./LayoutIntro/Header";
import FooterIntro from "./LayoutIntro/FooterIntro";
import Sidebar from "./LayoutIntro/Sidebar";
import SidebarWrapper from "./LayoutIntro/SidebarWrapper"; // ⬅️ Import the wrapper

const IntroLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <div className="flex flex-col min-h-screen">
      {/* Header with toggle control */}
      <Header onToggleSidebar={toggleSidebar} />

      {/* Sidebar controlled by state */}
      {/* <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} /> */}
      <SidebarWrapper
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <main className="flex-1">
        <Outlet />
      </main>

      <FooterIntro />
    </div>
  );
};

export default IntroLayout;
